import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Form, Col, Row, Label } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from '../../../../reducers/common/localization';
import { LABEL_PATH_BY_ORG_TYPE } from '../../../../reducers/organization/organizations';

class RemoveValidatedDomainModal extends Component {
    render() {
        return (
            <Modal className="validated-domain-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Form>
                <Label>
                    <h6>{_.get(this.props.translation, 'validated_domains.remove_domain_alert')}</h6>
                </Label>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.org_type_label')}:
                    </Col>
                    <Col>
                        {_.get(this.props.translation, sharedLabelsPath[LABEL_PATH_BY_ORG_TYPE[this.props.data.orgType]])}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.name_label')}:
                    </Col>
                    <Col>
                        {this.props.data.orgName}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, sharedLabelsPath.domain_label)}:
                    </Col>
                    <Col>
                        {this.props.data.orgDomain}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, sharedLabelsPath.country_label)}:
                    </Col>
                    <Col>
                        {_.get(this.props.translation, 'countries.' + this.props.data.orgCountry)}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.city_label')}:
                    </Col>
                    <Col>
                        {this.props.data.orgCity}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.postal_label')}:
                    </Col>
                    <Col>
                        {this.props.data.orgPostal}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.street_label')}:
                    </Col>
                    <Col>
                        {this.props.data.orgStreet}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'validated_domains.contact_name_label')}:
                    </Col>
                    <Col>
                        {this.props.data.contactName}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'validated_domains.contact_email_label')}:
                    </Col>
                    <Col>
                        {this.props.data.contactEmail}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'validated_domains.contact_phone_label')}:
                    </Col>
                    <Col>
                        {this.props.data.contactPhone}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'validated_domains.managed_by_label')}:
                    </Col>
                    <Col>
                        {_.get(this.props.translation, `validated_domains.${this.props.data.managedBy}_label`)}
                    </Col>
                </Row>
                <div className="modal-buttons-container">
                    <Button color='secondary'
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            onClick={this.handleRemove}>{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                </div>
            </Form>
        );
    }

    handleRemove = (e) => {
        e.preventDefault();

        this.props.onRemove(this.props.data.orgDomain);
        this.props.onCancel();
        this.props.onClose();
    };

    handleCancel = () => {
        this.props.onCancel();
        this.props.onClose();
    };
}

RemoveValidatedDomainModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onRemove: PropTypes.func,
    onCancel: PropTypes.func,
    onClose: PropTypes.func
};

export default RemoveValidatedDomainModal;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationModal/removeValidatedDomainModal/RemoveValidatedDomainModal.js